export default (toastr) => {
    let translations = window.translations_object;
    //toastr['warning'](translations['Invalid']);

    if (window.alertToast) {
        let type = window.alertToast.type;
        let msg = '';

        if (type === 'register') {
            msg = translations['Thank you for your inquiry {from} for our {course}. We will get back to you as soon as it is implemented.'].replace('{from}', window.alertToast.from).replace('{course}', window.alertToast.course);
        } else if (type === 'contact') {
            msg = translations['Thank you for your inquiry {from}. We will get back to you as soon as it is implemented.'].replace('{from}', window.alertToast.from);
        }

        toastr['success'](msg);
        let newURL = location.href.split("?")[0];
        window.history.replaceState('object', document.title, newURL);
    }
};